/**
 * @flow
 * @relayHash 3b068dfd54d873f0c6dab77b45139716
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type JobsAdminQueryResponse = {|
  +admin: ?{| |};
|};
*/


/*
query JobsAdminQuery(
  $count: Int!
  $cursor: String
  $isRecurring: Boolean
  $status: [JobStatus]
  $hasStudentRating: Boolean
  $hasTutorRating: Boolean
  $sessionStatus: [JobSessionStatus]
  $requestType: [JobRequestType]
) {
  admin {
    ...Jobs_admin_1G22uz
  }
}

fragment Jobs_admin_1G22uz on Admin {
  allJobs(first: $count, after: $cursor, isRecurring: $isRecurring, status: $status, hasStudentRating: $hasStudentRating, hasTutorRating: $hasTutorRating, sessionStatus: $sessionStatus, requestType: $requestType) {
    edges {
      node {
        __typename
        sessionCount
        paymentTutor
        paymentInternal
        paymentExternal
        createdAt
        id
        averageTutorRating
        averageStudentRating
        acceptedJobOffer {
          tutor {
            fullname
            id
          }
          jobRequest {
            student {
              fullname
              id
            }
            subject {
              description
              id
            }
            grade {
              name
              gradeGroup {
                name
                id
              }
              id
            }
            id
          }
          id
        }
        sessions {
          status
          rating {
            studentRating
            studentComment
            tutorRating
            tutorComment
            id
          }
          timeSlot {
            duration {
              totalMinutes
              id
            }
            startDate
            id
          }
          id
        }
        status
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "isRecurring",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "status",
        "type": "[JobStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasStudentRating",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasTutorRating",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "sessionStatus",
        "type": "[JobSessionStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "requestType",
        "type": "[JobRequestType]",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JobsAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Jobs_admin",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor",
                "type": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "JobsAdminQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "count",
        "type": "Int!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "cursor",
        "type": "String",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "isRecurring",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "status",
        "type": "[JobStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasStudentRating",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "hasTutorRating",
        "type": "Boolean",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "sessionStatus",
        "type": "[JobSessionStatus]",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "requestType",
        "type": "[JobRequestType]",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "JobsAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasStudentRating",
                "variableName": "hasStudentRating",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasTutorRating",
                "variableName": "hasTutorRating",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "isRecurring",
                "variableName": "isRecurring",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "requestType",
                "variableName": "requestType",
                "type": "[JobRequestType]"
              },
              {
                "kind": "Variable",
                "name": "sessionStatus",
                "variableName": "sessionStatus",
                "type": "[JobSessionStatus]"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status",
                "type": "[JobStatus]"
              }
            ],
            "concreteType": "JobConnection",
            "name": "allJobs",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "JobEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Job",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "paymentTutor",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "paymentInternal",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "paymentExternal",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "sessionCount",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "averageTutorRating",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "averageStudentRating",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "JobOffer",
                        "name": "acceptedJobOffer",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Tutor",
                            "name": "tutor",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "fullname",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "JobRequest",
                            "name": "jobRequest",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "Student",
                                "name": "student",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "fullname",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "id",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "Subject",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "description",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "id",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "Grade",
                                "name": "grade",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "name",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GradeGroup",
                                    "name": "gradeGroup",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "args": null,
                                        "name": "name",
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "args": null,
                                        "name": "id",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "id",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "JobSession",
                        "name": "sessions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "JobSessionRating",
                            "name": "rating",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "studentRating",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "studentComment",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "tutorRating",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "tutorComment",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeSlot",
                            "name": "timeSlot",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "Duration",
                                "name": "duration",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "totalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "id",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "startDate",
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "count",
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "hasStudentRating",
                "variableName": "hasStudentRating",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "hasTutorRating",
                "variableName": "hasTutorRating",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "isRecurring",
                "variableName": "isRecurring",
                "type": "Boolean"
              },
              {
                "kind": "Variable",
                "name": "requestType",
                "variableName": "requestType",
                "type": "[JobRequestType]"
              },
              {
                "kind": "Variable",
                "name": "sessionStatus",
                "variableName": "sessionStatus",
                "type": "[JobSessionStatus]"
              },
              {
                "kind": "Variable",
                "name": "status",
                "variableName": "status",
                "type": "[JobStatus]"
              }
            ],
            "handle": "connection",
            "name": "allJobs",
            "key": "Jobs_allJobs",
            "filters": [
              "isRecurring",
              "status",
              "hasStudentRating",
              "hasTutorRating",
              "sessionStatus",
              "requestType"
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query JobsAdminQuery(\n  $count: Int!\n  $cursor: String\n  $isRecurring: Boolean\n  $status: [JobStatus]\n  $hasStudentRating: Boolean\n  $hasTutorRating: Boolean\n  $sessionStatus: [JobSessionStatus]\n  $requestType: [JobRequestType]\n) {\n  admin {\n    ...Jobs_admin_1G22uz\n  }\n}\n\nfragment Jobs_admin_1G22uz on Admin {\n  allJobs(first: $count, after: $cursor, isRecurring: $isRecurring, status: $status, hasStudentRating: $hasStudentRating, hasTutorRating: $hasTutorRating, sessionStatus: $sessionStatus, requestType: $requestType) {\n    edges {\n      node {\n        __typename\n        sessionCount\n        paymentTutor\n        paymentInternal\n        paymentExternal\n        createdAt\n        id\n        averageTutorRating\n        averageStudentRating\n        acceptedJobOffer {\n          tutor {\n            fullname\n            id\n          }\n          jobRequest {\n            student {\n              fullname\n              id\n            }\n            subject {\n              description\n              id\n            }\n            grade {\n              name\n              gradeGroup {\n                name\n                id\n              }\n              id\n            }\n            id\n          }\n          id\n        }\n        sessions {\n          status\n          rating {\n            studentRating\n            studentComment\n            tutorRating\n            tutorComment\n            id\n          }\n          timeSlot {\n            duration {\n              totalMinutes\n              id\n            }\n            startDate\n            id\n          }\n          id\n        }\n        status\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/job/__generated__/JobsAdminQuery.graphql.js